import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { Form, FormSpy } from 'react-final-form'
import { FormattedMessage } from 'react-intl'
import { scrollToError } from '../../../../../dom-handlers'
import { connectCaptcha, getUserData, isStaff } from 'utils'
import MainGuestForm from '../../../../checkout/MainGuestForm'
import StaffCheckoutForm from '../../../../checkout/StaffCheckoutForm'
import { checkoutValidation } from '../../../../checkout/validation'
import Card from '../shared/Card'
import EnquirySidePanel from './EnquirySidePanel/EnquirySidePanel'
import styles from './ContactDetailsCard.module.scss'

const initialValues = getUserData()

ContactDetailsCard.propTypes = {
  onCheckoutFormSubmit: PropTypes.func.isRequired,
  shopKind: PropTypes.number.isRequired,
  orderEdit: PropTypes.bool,
  isEnquiry: PropTypes.bool,
  submitLabel: PropTypes.node,
  selectedTripData: PropTypes.object,
  countryCode: PropTypes.string,
}

export default function ContactDetailsCard({
  onCheckoutFormSubmit,
  shopKind,
  orderEdit,
  isEnquiry = false,
  submitLabel,
  selectedTripData,
  countryCode,
}) {
  const phoneInstance = useRef()

  const getPhoneInstance = (instance) => {
    phoneInstance.current = instance
  }

  useEffect(() => {
    connectCaptcha('captcha', countryCode)
  }, [])

  return (
    <Form
      onSubmit={onCheckoutFormSubmit}
      initialValues={initialValues}
      validate={(values) =>
        checkoutValidation(values, orderEdit, isEnquiry, phoneInstance.current)
      }
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit} className='la-step4-contact-form'>
          <FormSpy
            subscription={{ submitFailed: true }}
            onChange={scrollToError}
          />

          <Card className={styles.cardContact}>
            <div className={styles.formCol}>
              <p className={styles.cardTitle}>
                <FormattedMessage
                  id='your_contact_details'
                  defaultMessage='Your contact details'
                />
              </p>
              {!orderEdit && (
                <MainGuestForm
                  getPhoneInstance={getPhoneInstance}
                  handleSubmit={handleSubmit}
                  shopKind={shopKind}
                  countryCode={countryCode}
                />
              )}
              <div className={styles.captchaWrap}>
                <div id='captcha' />
              </div>
              <button type='submit' className={styles.submitBtn}>
                {submitLabel || (orderEdit ? (
                  <FormattedMessage
                    id='create_option'
                    defaultMessage='Update order'
                  />
                ) : (
                  <FormattedMessage
                    id='submit_enquiry'
                    defaultMessage='Submit Enquiry'
                  />
                ))}
              </button>
            </div>
            <div className={styles.sideCol}>
              <EnquirySidePanel />
            </div>
          </Card>

          {isStaff() && (
            <Card className={styles.cardStaff}>
              <p className={styles.cardTitle}>
                <FormattedMessage
                  id='staff_inputs_optional'
                  defaultMessage='PADI Travel staff inputs (optional)'
                />
              </p>
              <StaffCheckoutForm values={values} />
            </Card>
          )}
        </form>
      )}
    />
  )
}
